import React from 'react';
import {SoopAvatarCommon, SoopButtonIcon, SoopIcon} from '@soop-ui/soop-ui';
import styles from './ProfileInfo.module.scss';
import {useStationData, useStationUser} from '@/stores/channel/station';
import {sendClickLog} from '@/utils/main/my-plus/log';
import BadgeInfo from '@/components/channel/mobile/layout/home/Profile/Streamer/Badge';
import {RouterLink} from '@/components/channel/common/RouterLink';
import {ROUTE} from '@/constants/main/route';
import {useNamedNavigate} from '@/hooks/channel/useNamedNavigate';
import BtnNote from '@/components/channel/pc/home/ChannelVisual/ChannelInfo/StreamerInfo/Note';
import {useLocation} from 'react-router-dom';
import {goLogin, isLogin} from '@/utils/main';

const ProfileInfo = ({setIsInfoLayerOpen}) => {
  const {station} = useStationData();
  const {userId: streamerId} = station.detail || {};
  const {userPermissions} = useStationUser();
  const {isOwner} = userPermissions || {};
  const handleOpenStationInfo = async () => {
    setIsInfoLayerOpen((prev) => !prev);
  };
  const navigate = useNamedNavigate();
  const location = useLocation();
  const isLoggedIn = isLogin();

  const {pathname, state} = location;
  const prevBoardNumber = Number(state?.boardNumber ?? 0);

  const handleWriteClick = (prevBoardNumber) => {
    if (!isLoggedIn) {
      goLogin();
      return;
    }

    sendClickLog('station_click', {
      button_type: 'post_write',
    });
    const isPost = pathname.split('/')[3] === 'post';
    const isEdit = pathname.split('/')[5] === 'edit';
    const isBoard = pathname.split('/')[3] === 'board';
    const isGuest = pathname.split('/')[3] === 'guest';
    const isWrite = pathname.split('/')[4] === 'write';
    const boardNumber = pathname.split('/')[4] ?? 0;

    if (isPost && isWrite) {
      return;
    }
    // 게시글 상세 페이지 일때
    if (isPost && !isWrite) {
      navigate(
        `/station/${streamerId}/post/write${prevBoardNumber ? `/${prevBoardNumber}` : ''}`,
      );
      return;
    }
    // 게시판 리스트 일떄,
    if (isBoard || isGuest) {
      navigate(
        `/station/${streamerId}/post/write${boardNumber ? `/${boardNumber}` : ''}`,
      );
      return;
    }
    if (isPost && isEdit) {
      navigate(`/station/${streamerId}/post/write`);
      return;
    }
    navigate(`/station/${streamerId}/post/write`);
  };

  const handleCalendarClick = () => {
    navigate(ROUTE.CHANNEL.SERVICE.CALENDAR, {
      streamerId: streamerId!,
    });
  };

  return (
    <>
      <div className={styles.streamer}>
        <div className={styles.profileImg}>
          <RouterLink
            name={ROUTE.CHANNEL.SERVICE.HOME}
            params={{streamerId: streamerId ?? ''}}
            onClick={() => {
              sendClickLog('station_click', {
                button_group: 'station_lnb',
                button_type: 'home',
              });
            }}>
            <SoopAvatarCommon
              className={styles.profile}
              mode='static'
              size={80}
              userId={streamerId}
              variant='default'
            />
            {!isOwner && <BtnNote />}
          </RouterLink>
        </div>

        <div className={styles.nicknameWrapper}>
          <p className={styles.nick}>{station.detail?.nickname}</p>
          <SoopButtonIcon
            className={styles.infoButton}
            onClick={handleOpenStationInfo}
            iconName='icoEtcInfoFill'
            variant='clearPrimary'
            size={24}>
            방송국 정보
          </SoopButtonIcon>
        </div>
        {<BadgeInfo />}
        <div className={styles.btnWrap}>
          <button onClick={() => handleWriteClick(prevBoardNumber)}>
            <SoopIcon
              fill='var(--soop-mode-fill-fillTertiary)'
              name='icoPen'
              width='20px'
              height='20px'
            />
            글쓰기
          </button>
          <button onClick={handleCalendarClick}>
            <SoopIcon
              fill='var(--soop-mode-fill-fillTertiary)'
              name='icoCalendar-06'
              width='20px'
              height='20px'
            />
            캘린더
          </button>
        </div>
      </div>
    </>
  );
};

export default ProfileInfo;
